import React from 'react';
import { X } from 'lucide-react';
import EditItemForm from './stash/EditItemForm';

/**
 * Edit Item Modal (used on desktop)
 * Wraps EditItemForm in a modal overlay
 */
const EditItemModal = ({ isOpen, onClose, item, onSuccess, autoOpenChangeImage = false }) => {
  if (!isOpen || !item) return null;

  const handleSuccess = () => {
    onSuccess();
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-charcoal/60 flex items-center justify-center z-[60] p-4">
      <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-hidden shadow-2xl flex flex-col">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-beige p-6 flex items-center justify-between z-20 shrink-0">
          <h2 className="text-2xl font-light text-charcoal">Edit Item</h2>
          <button onClick={onClose} className="text-gray-soft hover:text-charcoal transition-colors" data-testid="close-edit-modal">
            <X size={24} />
          </button>
        </div>

        {/* Form */}
        <div className="flex-1 overflow-y-auto">
          <EditItemForm
            item={item}
            onSuccess={handleSuccess}
            onCancel={onClose}
            autoOpenChangeImage={autoOpenChangeImage}
            isFullScreen={false}
          />
        </div>
      </div>
    </div>
  );
};

export default EditItemModal;
